module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/nba/new_survive-2c9beff6984aae04a8333b2a7679c9e8.png";